import styled from "styled-components";
import Button from "../common/Button";

const TowerWriteActionButtonsBlock = styled.div`
    // margin-top: 1rem;
    // margin-bottom: 3rem;
    margin: 1rem 1rem 3rem;
    display: flex;
    justify-content: center;
`;

// TagBox에서 사용하는 버튼과 일치하는 높이로 설정한 후 서로 간의 여백 지정
const StyledButton = styled(Button)`
    height: 2.125rem;
    & + & {
        margin-left: 0.5rem;
    }
`;

const TowerWriteActionButtons = ({ onPublish, onCancel, isEdit }) => {

    return (
        <TowerWriteActionButtonsBlock>
            <StyledButton cyan onClick={onPublish}>Transfer Tower {isEdit ? 'Edit' : 'Add'}</StyledButton>
            <StyledButton onClick={onCancel}>Cancel</StyledButton>
        </TowerWriteActionButtonsBlock>
    );
};

export default TowerWriteActionButtons;